import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, Scene } from 'react-scrollmagic';

import PresentationBlock from '../../containers/presentation-block';
import imgMob from '../../images/white-label/wl_logo-mob.png';
import imgMob2x from '../../images/white-label/wl_logo-mob2x.png';
import img from '../../images/white-label/wl_logo.png';
import img2x from '../../images/white-label/wl_logo2x.png';
import { WL_PRICING } from '../../links';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
    padding: theme.spacing(10, 0, 8),
    backgroundColor: theme.palette.common.black,
    backgroundImage:
      'radial-gradient(87.04% 212.32% at 95.46% -27.14%, #02BBD3 0%, #0030AC 100%)',
    [theme.breakpoints.down('xs')]: {
      minHeight: 584
    },
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(12),
      paddingBottom: theme.spacing(16)
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
      paddingTop: theme.spacing(18),
      paddingBottom: theme.spacing(25.5)
    }
  },
  animate: {
    position: 'relative',
    top: 20,
    transition:
      'opacity 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955), top 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955)',
    opacity: 0
  },
  show: {
    top: 0,
    opacity: 1
  },
  imgWrap: {
    position: 'absolute',
    right: 0,
    bottom: '-16%',
    width: '68%',
    height: 'auto',
    [theme.breakpoints.up('sm')]: {
      bottom: '-10%'
    },
    [theme.breakpoints.up('md')]: {
      bottom: '-15%',
      width: '58%'
    },
    [theme.breakpoints.up('lg')]: {
      width: '68%'
    }
  },
  wrap: {
    position: 'relative',
    zIndex: 1,
    [theme.breakpoints.up('md')]: {
      maxWidth: 932
    }
  },
  title: {
    marginBottom: theme.spacing(6),
    fontSize: '2.5rem',
    fontWeight: 800,
    color: theme.palette.common.white,
    transitionDelay: '0.1s',
    [theme.breakpoints.up('md')]: {
      maxWidth: 654,
      marginBottom: theme.spacing(14),
      fontSize: '3.5rem'
    }
  },
  button: {
    width: '100%',
    transitionDelay: '0.4s',
    [theme.breakpoints.up('sm')]: {
      width: 'auto'
    }
  }
}));

const TitleBlockContent = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <PresentationBlock className={classes.root}>
      <img
        className={classes.imgWrap}
        src={matches ? img : imgMob}
        srcSet={matches ? `${img2x} 2x` : `${imgMob2x} 2x`}
        alt=""
      />
      <Container maxWidth="xl">
        <Controller>
          <Scene
            classToggle={[`.${classes.animate}`, `${classes.show}`]}
            triggerElement="#whiteLabel"
            indicators={false}
            reverse={false}
          >
            <div className={classes.wrap} id="whiteLabel">
              <Typography
                variant="h1"
                className={clsx(classes.title, classes.animate)}
              >
                {t('whiteLabelPage.titleBlock.title')}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                className={clsx(classes.button, classes.animate)}
                href={WL_PRICING}
              >
                {t('whiteLabelPage.titleBlock.link')}
              </Button>
            </div>
          </Scene>
        </Controller>
      </Container>
    </PresentationBlock>
  );
};

export default TitleBlockContent;
